




























import Vue from "vue";
import CardDetail from "../Common/CardDetail.vue";
import CommonModalScreen from '../Common/CommonModalScreen.vue';
import DeleteButton from '../Common/DeleteButton.vue';
import ItemPage from '../Common/ItemPage.vue';
import { SelectedGiftBag } from "@/components/CartCommon/cart";
import { alertError } from "@/util/alert_errors";

export default Vue.extend({
  props: {
    itemIndex: Number as () => number,
    giftBag: Object as () => SelectedGiftBag,
    currentGiftBag: Boolean,
  },
  data() {
    return {
      isModalOpen: false,
      modalTransition: { name: "modal-transition" },
    };
  },
  components: {
    CardDetail,
    CommonModalScreen,
    DeleteButton,
    ItemPage,
  },
  computed: {
    modalName(): string {
      return `cart-modal-giftbag-${this.itemIndex}-${this.giftBag.id}`;
    },
    images(): Array<string> {
      if(this.giftBag.id === 2) {
        return [
          require("@/assets/images/cart2019/giftshopper_sample1.jpg"),
          require("@/assets/images/cart2019/giftshopper_sample2.jpg"),
          require("@/assets/images/cart2019/giftshopper_sample3.jpg"),
        ];
      } else {
        return [
          require("@/assets/images/cart2019/giftshopper_fabric1.jpg"),
          require("@/assets/images/cart2019/giftshopper_fabric2.jpg"),
          require("@/assets/images/cart2019/giftshopper_fabric3.jpg"),
          require("@/assets/images/cart2019/giftshopper_fabric4.jpg"),
          require("@/assets/images/cart2019/giftshopper_fabric5.jpg"),
          require("@/assets/images/cart2019/giftshopper_fabric6.jpg"),
        ];
      }
    },
    description(): string {
      if(this.giftBag.id === 2) {
        return "プレゼントを入れるのにぴったりなギフトショッパーです。\n誕生日プレゼントや結婚祝い、お礼、内祝いなどシーンを選ばずにご利用いただけるシンプルなデザイン。折りたたんだ状態で、品物と一緒に梱包してお届けします。\n\n・サイズ：200×90×200mm（持ち手含まず） \n・素材：紙（持ち手含まず）\n\n※商品と同時にご注文いただけますが、発送時の袋入れサービスを行っておりません。手提げ袋の販売、同梱発送となりますため、商品到着後にお客様自身にて袋入れをしていただく必要がございます\n※ご注文された商品の点数、そのほかオプションとの組み合わせ、あるいは入れ方などによっては、袋入れの際にすべてが入り切らない場合がございます。手提げ袋のサイズをはじめ、商品サイズ、オプションサイズなどもサイト内でご案内しております。ご参考にご検討ください".replace(/\n/g, '<br>');
      } else {
        return "プレゼントを入れるのにぴったりなギフトショッパーです。\n誕生日プレゼントや結婚祝い、お礼、内祝いなどシーンを選ばずにご利用いただけるシンプルなデザイン。折りたたんだ状態で、品物と一緒に梱包してお届けします。\n\n・本体サイズ：縦380×横270mm程度（持ち手含まず） \n・持ち手の長さ：250mm程度（縛った状態で片側の長さ）\n・素材：コットン\n\n※商品の色味の目安は商品単体の画像をご参照ください\n※商品と同時にご注文いただけますが、発送時の袋入れサービスを行っておりません。手提げ袋の販売、同梱発送となりますため、商品到着後にお客様自身にて袋入れをしていただく必要がございます\n※ご注文された商品の点数、そのほかオプションとの組み合わせ、あるいは入れ方などによっては、袋入れの際にすべてが入り切らない場合がございます。手提げ袋のサイズをはじめ、商品サイズ、オプションサイズなどもサイト内でご案内しております。ご参考にご検討ください".replace(/\n/g, '<br>');
      }
    },
    imageDescriptions(): Array<string> {
      if(this.giftBag.id === 2) {
        return ["ツヤのある質感", "高級感のある金色の箔加工", "持ち手には太めのリボンを使用"];
      } else if(this.giftBag.id === 3) {
        return ["コットン素材のギフトバッグ", "さりげないワンポイントロゴ", "ラッピングイメージ　※こちらはセルフラッピングの商品です", "サイズ感イメージ", "しっかりとした生地で、普段使いも可能", "ちょっとした外出や、旅先での小物入れなどに便利なバッグ"];
      }
      return [];
    },
  },
  methods: {
    onClick() {
      // スクロール中にカードのクリック操作が起きないように
      // ItemSelectorでdraggingを制御
      if (window.dragging) {
        return;
      };

      this.isModalOpen = true;
    },
    onCancel() {
      this.isModalOpen = false;
    },
    async onConfirm() {
      this.updateGiftBag(this.giftBag);
    },
    onDeleteOption() {
      this.updateGiftBag(null);
    },
    async updateGiftBag(giftBag) {
      try {
        await this.$store
          .dispatch("updateGiftBag", {
            itemId: this.itemIndex,
            giftBag: giftBag,
          })
          .catch(() => {
            throw new Error("エラーが発生しました");
          });
        this.isModalOpen = false;
      } catch (e) {
        alertError(e);
      }
    },
  },
});
